import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import http from './http';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import './vee-validate';
import { localize } from 'vee-validate';
import { AppConfig, AppConfigSchema } from './types/config';

fetch(`config.json?version=${Date.now()}`)
  .then((res) => res.json())
  .then((configJSON) => {
    // ✅ Validate with Zod
    const parsed = AppConfigSchema.safeParse(configJSON)
    if (!parsed.success) {
      console.error('❌ Invalid config.json:', parsed.error.format())
      throw new Error('Invalid configuration file')
    }

    const config: AppConfig = parsed.data

    store.state.config = configJSON
    Vue.prototype.$config = configJSON
    Vue.config.productionTip = false;

    Vue.use(BootstrapVue);
    Vue.use(IconsPlugin);
    Vue.use(http);
    store.commit('initialiseStore')

    const app = new Vue({
      router,
      store,
      render: h => h(App),
      provide: { 'config': config }
    }).$mount('#app')

    /* ****** Settings the vee-validate error message in the current language ******* */
    localize(store.getters.lang);

  })
  .catch((err) => {
    console.error('🚨 Failed to load config.json:', err)
    alert('Configuration error — check console logs.')
  })
